import moment, { Moment } from 'moment';

moment.locale('fr');

type DoctrineDate = Date | string | Moment;

export const getDateKey = (date: DoctrineDate) =>
  moment(date).format('YYYY-MM-DD');

export const getFormattedDate = (date: DoctrineDate) =>
  moment(date).format('LL');

export const getShortFormattedDate = (date: DoctrineDate) =>
  moment(date).format('DD MMM');

export const getShortFormattedDateWithYear = (date: DoctrineDate) =>
  moment(date).format('DD MMM YYYY');

export const getNowDate = () => moment();

export const getDateFromString = (dateString: string) => moment(dateString);

export const parseDateWithKeyFormat = (dateString: string) =>
  moment(dateString, 'YYYY-MM-DD');

export const getTimestampFromKeyFormat = (dateString: string) =>
  parseDateWithKeyFormat(dateString).valueOf();

export const getTimeInLetters = (time: any) =>
  moment.duration(time, 'seconds').humanize();

export const aggregateDate = (day: number, month: string, year: number) =>
  moment()
    .year(year)
    .month(month) // moment.month should be number|string in flow-typed definition
    .date(day)
    .format('DD/MM/YYYY');

const getYesterdayOrTodayDate = (
  pastDays: number,
): "aujourd'hui" | 'hier' | false => {
  if (pastDays === 0) return "aujourd'hui";
  if (pastDays === 1) return 'hier';
  return false;
};

export const formatDateFromNow = (date: string): string => {
  const dateFormatted = moment(date);
  const pastDays = moment().diff(dateFormatted, 'days');
  const yesterdayOrToday = getYesterdayOrTodayDate(pastDays);
  return yesterdayOrToday || getFormattedDate(dateFormatted);
};

export const formatShortDateFromNow = (date: string): string => {
  const dateFormatted = moment(date);
  const pastDays = moment().diff(dateFormatted, 'days');
  const yesterdayOrToday = getYesterdayOrTodayDate(pastDays);
  return yesterdayOrToday || getShortFormattedDate(dateFormatted);
};

const getPastDaysFormattedDate = (pastDays: number) => {
  if (pastDays <= 1) {
    return `il y a ${pastDays} jour`;
  }
  return `il y a ${pastDays} jours`;
};

export const formatGenericDate = (date: string): string => {
  const dateFormatted = moment(date);
  const pastDays = moment().diff(dateFormatted, 'days');
  const yesterdayOrToday = getYesterdayOrTodayDate(pastDays);
  if (yesterdayOrToday) {
    return yesterdayOrToday;
  }
  if (pastDays <= 7) {
    return getPastDaysFormattedDate(pastDays);
  }
  const pastYears = moment().diff(dateFormatted, 'year');
  if (pastYears === 0) {
    return getShortFormattedDate(dateFormatted);
  }

  return getShortFormattedDateWithYear(dateFormatted);
};

export const getMonth = (n: number): string => moment.months(n - 1);
